import React from 'react';

function ProcessSection() {
    const steps = [
        {
            id: 1,
            title: "Submit Your Content",
            description: "Fill out our submission form with your details. Our team will reach out within 2–3 working days."
        },
        {
            id: 2,
            title: "Partnership Discussion",
            description: "We walk you through distribution terms, preferences, format requirements, and onboarding steps."
        },
        {
            id: 3,
            title: "Content Launch",
            description: "Once your content meets quality and format standards, we take it LIVE on our platform."
        },
        {
            id: 4,
            title: "Performance-based Revenue",
            description: "You earn a share of ad revenue based on the impressions your content generates. More views = more earnings."
        }
    ];

    return (
        <section className="partnership-section process-section">
            <div className="process-curve-bg">
                <img
                    src="/assets/images/AdobeStock.svg"
                    alt=""
                    className="process-curve-img"
                />
            </div>

            <div className="container process-container">
                <div className="mb-5 text-center text-lg-start">
                    <h2 className="partnership-title">
                        How It Works
                    </h2>
                </div>

                <div className="row g-4 text-center process-row">
                    {steps.map((step) => (
                        <div className="col-lg-3 col-md-6 process-step-col" key={step.id}>
                            {/* STEP Implementation */}
                            <div className="process-step-circle">
                                {/* Purple Circle Background */}
                                <img
                                    src="/assets/images/PurpleCircle.svg"
                                    alt="Background"
                                    className="process-circle-img"
                                />
                                {/* Number */}
                                <img
                                    src={`/assets/images/${step.id}.svg`}
                                    alt={step.id}
                                    className="process-number-img"
                                />
                            </div>

                            {/* Text Content */}
                            <div className="process-step-content">
                                <h3 className="process-step-title">
                                    {step.title}
                                </h3>
                                <p className="process-step-desc">
                                    {step.description}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Bottom Divider */}
            <div className="partnership-footer-divider">
                <img
                    src="/assets/images/divfooter4.svg"
                    alt=""
                    className="img-fluid"
                />
            </div>
        </section>
    );
}

export default ProcessSection;
